<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <span style="font-size: 24px;">KPI's de Ventas</span>
          <div class="card-header-actions" style="width: 800px; margin-right: 18px;">
            <CRow>     
              <CCol md="4" style="text-align: right; padding-right: 0px;">                
              </CCol>                      
              <CCol md="4" style="text-align: right; padding-right: 0px;">
                <CSelect v-if="providersOptions.length > 2"
                  :value.sync="providerSelected" 
                  :options="providersOptions"
                  @change="reloadGraphs"
                />
              </CCol>       
              <CCol md="4" style="text-align: right; padding-right: 0px;">
                <CSelect
                  :value.sync="month" 
                  :options="monthOptions"
                  @change="reloadGraphs"
                />
              </CCol>       
            </CRow>
          </div>
        </slot>
      </CCardHeader>
      <CCardBody>
        <CRow>      
          <CCol md="12">
              <CRow>                                           
                <CCol md="4">
                  <CCard>
                    <SellersWithSales ref="sellerWithSales" title="Vendedores con Ventas" :month="month" :provider="providerSelected"></SellersWithSales>
                  </CCard>      
                </CCol>     
                <CCol md="4">
                  <CWidgetSimple style="height: 280px;">
                    <CRow>  
                      <CCol md="12"> 
                        <CustomersReached ref="customersReached" title="Clientes Alcanzados:" :month="month" :provider="providerSelected"></CustomersReached>
                      </CCol> 
                    </CRow>
                  </CWidgetSimple>
                </CCol>     
                <CCol md="4">
                  <MonthSales ref="monthSales" title="Ventas del Mes:" :month="month" :provider="providerSelected"></MonthSales>
                </CCol>     
              </CRow>              
          </CCol>                   
        </CRow>
        <CRow>             
          <CCol md="6">
            <CedisPerformance ref="cedisPerformance" title="Desempeño por CEDIS" :month="month" :provider="providerSelected"></CedisPerformance>
          </CCol>                       
          <CCol md="6">
            <MonthPerformance ref="monthPerformance" title="Venta por Mes" :month="month" :provider="providerSelected"></MonthPerformance>
          </CCol>  
        </CRow>
        <CRow>             
          <CCol md="12"><br/><br/><br/></CCol>  
        </CRow>
        <CRow>          
          <CCol md="12">
            <ProjectionTable ref="projectionTable" title="Venta por Mes" :month="month" :provider="providerSelected"></ProjectionTable>
          </CCol>                       
        </CRow>
        <CRow>             
          <CCol md="12"><br/><br/><br/></CCol>  
        </CRow>
        <CRow>          
          <CCol md="12" class="text-center">
            <h3>Participación en Distribución Clientes</h3>
            <br />
          </CCol>      
          <CCol md="10" style="text-align: right; padding-right: 0px;">                
            </CCol>                      
            <CCol md="2" style="text-align: right; padding-right: 12px;">
              <CSelect
                  :value.sync="cedis" 
                  :options="cedisOptions"
                  @change="reloadCustomerGraphs"
                />
            </CCol>     
          <CCol md="6">
            <CustomersDistributionGraph ref="customersDistributionGraph" title="" :month="month" :provider="providerSelected"></CustomersDistributionGraph>
          </CCol>      
          <CCol md="6">
            <CustomersDistribution ref="customerDistribution" title="" :month="month" :provider="providerSelected"></CustomersDistribution>
          </CCol>                       
        </CRow>
        <CRow>     
          <CCol md="8" style="text-align: right; padding-right: 0px;">                
          </CCol>                      
          <CCol md="4" style="text-align: right; padding-right: 0px;">
            <CSelect
              :value.sync="cedisSale" 
              :options="cedisOptions"
              @change="reloadSaleCedisGraphs"
            />
          </CCol>       
        </CRow>
        <CRow>             
          <CCol md="12">
            <MonthSalesCedis ref="monthSalesCedis" title="Venta CDIS" :month="month" :provider="providerSelected"></MonthSalesCedis>
          </CCol>                       
        </CRow>        
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import ws from '../../services/dashboards';
import providersWs from '../../services/providers';
import moment from 'moment';

import SellersWithSales from '../../components/graphs/SellersWithSales.vue';
import CustomersReached from '../../components/graphs/CustomersReached.vue';

import MonthSales from '../../components/graphs/MonthSales.vue';
import CedisPerformance from '../../components/graphs/CedisPerformance.vue';
import MonthPerformance from '../../components/graphs/MonthPerformance.vue';
import MonthSalesCedis from '../../components/graphs/MonthSalesCedis.vue';

import CustomersDistribution from '../../components/graphs/CustomersDistribution.vue';
import CustomersDistributionGraph from '../../components/graphs/CustomersDistributionGraph.vue';

import ProjectionTable from '../../components/graphs/ProjectionTable.vue';

export default {
  name: 'Dashboard',
  components: {
    MonthSales,
    CustomersReached,
    SellersWithSales,
    CedisPerformance,
    MonthSalesCedis,
    MonthPerformance,
    CustomersDistribution,
    CustomersDistributionGraph,
    ProjectionTable
  },
  data () {
    return {
      monthOptions: [],
      month: moment().format('YYYYMM'),
      cedisOptions: [],
      cedis: '',
      cedisSale: '',
      providersOptions: [],
      providerSelected: '0',
    }
  },
  async mounted () {
    if (this.redirectByRole()) {
      return;
    }

    await this.loadFilters();
  },
  methods: {
    redirectByRole () {
      const role = localStorage.getItem('role');
      if (role === 'administrator') {
        return false;
      }

      const targetPath = role === 'kam' ? '/home' : (role === 'supplier' || role === 'manager' ? '/welcome' : '/404');
      const currentPath = this.$route && this.$route.path ? this.$route.path : '';

      if (currentPath === targetPath) {
        return false;
      }

      if (this.$router) {
        this.$router.replace(targetPath);
      } else {
        window.location.href = '/#' + targetPath;
      }

      return true;
    },

    async loadFilters () {
      const [monthsRes, cedisRes, providersRes] = await Promise.all([
        ws.getMonths(),
        ws.getCedis(),
        providersWs.get(),
      ]);

      if (monthsRes.type === 'success') {
        this.monthOptions = monthsRes.data;
      }

      if (cedisRes.type === 'success') {
        this.cedisOptions = cedisRes.data;

        if (!this.cedis && this.cedisOptions.length > 0) {
          this.cedis = String(this.cedisOptions[0].value ?? this.cedisOptions[0].id ?? '');
        }

        if (!this.cedisSale && this.cedisOptions.length > 0) {
          this.cedisSale = String(this.cedisOptions[0].value ?? this.cedisOptions[0].id ?? '');
        }
      }

      if (providersRes.type === 'success') {
        this.providersOptions = await this.$parseSelectOptionsOrdered(
          providersRes.data,
          'id',
          'name',
          [{ value: '0', label: 'Todos los Proveedores' }]
        );

        if (!this.providerSelected && this.providersOptions.length > 0) {
          this.providerSelected = String(this.providersOptions[0].value ?? '0');
        }
      }
    },

    reloadRef (refName, ...args) {
      const ref = this.$refs[refName];
      if (!ref || typeof ref.reloadGraph !== 'function') {
        return Promise.resolve();
      }

      return ref.reloadGraph(...args);
    },

    async reloadGraphs () {
      await Promise.all([
        this.reloadRef('sellerWithSales', this.month, this.providerSelected),
        this.reloadRef('customersReached', this.month, this.providerSelected),
        this.reloadRef('monthSales', this.month, this.providerSelected),
        this.reloadRef('cedisPerformance', this.month, this.providerSelected),
        this.reloadRef('monthPerformance', this.month, this.providerSelected),
        this.reloadRef('projectionTable', this.month, this.providerSelected),
        this.reloadRef('customersDistributionGraph', this.month, this.providerSelected),
        this.reloadRef('customerDistribution', this.month, this.providerSelected, this.cedis),
        this.reloadRef('monthSalesCedis', this.month, this.providerSelected, this.cedisSale),
      ]);
    },

    async reloadCustomerGraphs () {
      await this.reloadRef('customerDistribution', this.month, this.providerSelected, this.cedis);
    },

    async reloadSaleCedisGraphs () {
      await this.reloadRef('monthSalesCedis', this.month, this.providerSelected, this.cedisSale);
    }
  }
}
</script>

<style>
  #dates .card-body{
    padding: 0 !important;
  }

  .text-value{
    font-size: 32px;
    text-align: right;
  }

  .text-muted{
    font-size: 18px;
    text-align: right;
  }

  .widget .card-body div:nth-child(2) {
    width: 100%;
  }

  .form-group{
    margin: 0px;
  }

  #total_balance .card-body div:nth-child(2) {
    width: 100%;
  }

  .good{
    background-color: #b0d136;
    color: black;
  }

  .bad{
    background-color: #f04922;
    color: white;
  }

  .metric .card-body {
    padding: 0px 14px;
  }
</style>